export default __webpack_public_path__ + "static/media/card.39754c29.png";